import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/ThankYou.css';

const ThankYou = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("orderId");
  const amount = queryParams.get("amount");

  const [saveStatus, setSaveStatus] = useState('');

  useEffect(() => {
    const appointmentData = sessionStorage.getItem("appointmentData");

    if (appointmentData && orderId) {
      const parsedData = JSON.parse(appointmentData);

      const finalData = {
        ...parsedData,
        orderId,
        amount,
        paymentStatus: 'Paid',
      };

      fetch('/api/appointments/astrology', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(finalData),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setSaveStatus('✅ Appointment saved successfully.');
            sessionStorage.removeItem("appointmentData");
          } else {
            setSaveStatus('⚠️ Appointment save failed.');
          }
        })
        .catch((err) => {
          console.error("Save error:", err);
          setSaveStatus('❌ Error saving appointment.');
        });
    }
  }, [orderId]);

  return (
    <div className="thankyou-container">
      <h1>🎉 Thank You!</h1>
      <p>Your appointment has been successfully booked and payment was received.</p>
      <p><strong>Order ID:</strong> {orderId}</p>
      <p><strong>Amount Paid:</strong> ₹{amount}</p>
      {saveStatus && <p>{saveStatus}</p>}
      <a href="/" className="back-home">Go to Home</a>
    </div>
  );
};

export default ThankYou;
